type StepperWithNumbersProps = {
  steps: number[]
  curStep: number
}

export const StepperWithNumbers = ({ steps, curStep }: StepperWithNumbersProps) => {
  return (
    <div className="flex items-center gap-2 mb-6 text-xs">
      {steps.map((step, index) => (
        <div
          key={`${step}-${index}`}
          className="flex items-center"
        >
          <div
            className={`rounded-full w-6 h-6 flex items-center justify-center border ${
              curStep === index
                ? 'bg-primary-600 text-white border-primary-700'
                : index < curStep
                  ? 'bg-primary-600 text-white border-primary-700'
                  : 'bg-white text-primary-400 border-primary-200'
            }`}
          >
            {step}
          </div>
          {index !== steps.length - 1 && <hr className="w-6 border-t border-primary-200 mx-1" />}
        </div>
      ))}
    </div>
  )
}

type StepperWithTextProps = {
  steps: string[]
  curStep: number
}

export const StepperWithText = ({ steps, curStep }: StepperWithTextProps) => {
  return (
    <div className="flex items-center mb-6 text-xs">
      {steps.map((stepLabel, index) => (
        <div
          key={`${stepLabel}-${index}`}
          className="flex items-center"
        >
          <div
            className={`${
              curStep === index
                ? 'text-primary-600 border-primary-700'
                : index < curStep
                  ? 'text-primary-600 border-primary-700'
                  : 'text-primary-400 border-primary-200'
            }`}
          >
            {stepLabel}
          </div>
          {index !== steps.length - 1 && <hr className="w-6 border-t border-primary-200 mx-2" />}
        </div>
      ))}
    </div>
  )
}
